/* Kích thước theo board Mint-Hub: thẻ 460, bo 24, đệm 30/34/22; nút SSO cao 46 bo 12; icon app 40. */

.root {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  background: var(--bg-grad);
}

.deco {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.dot {
  fill: var(--dot);
}
.route {
  fill: none;
  stroke: var(--route);
  stroke-width: 2;
  stroke-dasharray: 6 8;
}

.top {
  position: absolute;
  left: 40px;
  right: 40px;
  top: 24px;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.brand {
  flex-grow: 1;
  font-size: 16px;
  font-weight: var(--fw-title);
}
.greet {
  display: none;
}
.iconBtn {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 11px;
  background: var(--glass-soft);
  color: var(--tx2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  position: absolute;
  left: 50%;
  top: 50%;
  width: min(460px, calc(100% - 32px));
  transform: translate(-50%, -50%);
  padding: 30px 34px 22px;
  border-radius: 24px;
  background: var(--glass);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: var(--glass-sh);
}

.ret {
  margin-bottom: 16px;
  height: 36px;
  padding: 0 12px 0 4px;
  border-radius: 18px;
  background: var(--pri-bg);
  color: var(--link);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: var(--fw-label);
  max-width: 100%;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: var(--fw-title);
  letter-spacing: -0.02em;
}
.sub {
  margin: 4px 0 0;
  color: var(--tx2);
}

.apps {
  list-style: none;
  margin: 18px 0 0;
  padding: 0;
  display: flex;
  gap: 8px;
}
.app {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--lb);
}

.sso {
  margin-top: 22px;
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 12px;
  background: var(--btn);
  color: var(--btn-tx);
  font-size: 14px;
  font-weight: var(--fw-label);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  white-space: nowrap;
}

.alert {
  margin-bottom: 16px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--err-bg);
  color: var(--err);
}
.alert b {
  font-weight: var(--fw-label);
}

.title2 {
  margin: 16px 0 0;
  font-size: 22px;
  font-weight: var(--fw-title);
  letter-spacing: -0.02em;
}

/* đang chuyển tới Microsoft: Hub ┄┄┄ Microsoft */
.hop {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dash {
  flex-grow: 1;
  height: 2px;
  background: repeating-linear-gradient(90deg, var(--pri) 0 6px, transparent 6px 12px);
}
.ms {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--card);
  box-shadow: var(--sh);
  display: flex;
  align-items: center;
  justify-content: center;
}
.bar {
  margin-top: 18px;
  height: 4px;
  border-radius: 2px;
  background: var(--ctl);
  overflow: clip;
}
.bar > i {
  display: block;
  width: 60%;
  height: 4px;
  border-radius: 2px;
  background: var(--pri);
}
@media (prefers-reduced-motion: no-preference) {
  .bar > i {
    animation: hbBar 1.4s ease-in-out infinite;
  }
}
@keyframes hbBar {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(170%);
  }
}

/* nút phụ (viền) */
.btn2 {
  margin-top: 10px;
  width: 100%;
  height: 42px;
  border: 1px solid var(--bd);
  border-radius: 12px;
  background: transparent;
  color: var(--tx);
  font: inherit;
  font-weight: var(--fw-label);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
}

/* ô icon trạng thái (lỗi / cảnh báo / xong) */
.badge {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.badgeErr {
  background: var(--err-bg);
  color: var(--err);
}
.badgeWarn {
  background: var(--warn-bg);
  color: var(--warn);
}
.badgeOk {
  background: var(--ok-bg);
  color: var(--ok);
}

.note {
  margin: 10px 0 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--warn-bg);
  color: var(--warn);
  font-size: 12px;
}

.foot {
  margin-top: 10px;
  font-size: 12px;
  color: var(--lb);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Dòng hỗ trợ IT cuối thẻ (board Mint-Hub: cách 20 · đường kẻ · đệm trên 12 · canh phải) */
.help {
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid var(--bd);
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: var(--lb);
}
.help > span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* Hiệu ứng rê chuột (QĐ 28/Oct): icon app nảy + nhãn xanh, nút SSO nhấc và sáng. Không nhấc thẻ (thẻ có blur → giật). */
@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .app {
    transition: color 180ms;
  }
  .app > :global(.hana-appicon) {
    transition: transform 220ms cubic-bezier(0.3, 1.6, 0.5, 1), filter 220ms;
  }
  .app:hover {
    color: var(--brand);
  }
  .app:hover > :global(.hana-appicon) {
    transform: translateY(-4px) scale(1.12);
    filter: drop-shadow(0 6px 10px rgba(12, 18, 32, 0.22));
  }
  .sso {
    transition: transform 160ms, box-shadow 200ms, filter 200ms;
  }
  .sso:hover {
    transform: translateY(-1px);
    box-shadow: var(--sh-hi);
    filter: brightness(1.15);
  }
  .sso:active {
    transform: translateY(0);
  }
}

/* Mint-Hub-Phone khung 1: đầu trang 48px, thẻ neo đáy không nền, chữ 28 / nút 52 */
@media (max-width: 520px) {
  .top {
    left: 20px;
    right: 20px;
    top: 24px;
    height: 48px;
  }
  .iconBtn {
    width: 48px;
    height: 48px;
    border-radius: 14px;
  }
  .brand {
    font-size: 17px;
  }
  .card {
    top: auto;
    bottom: 24px;
    width: auto;
    left: 22px;
    right: 22px;
    transform: none;
    padding: 0;
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
  .card {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .title {
    font-size: 28px;
  }
  .sub {
    margin: 0;
    font-size: 16px;
  }
  .sso {
    height: 52px;
    font-size: 16px;
    margin-top: 0;
    border-radius: 14px;
  }
  .apps {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin: 8px 0;
  }
  .app {
    gap: 6px;
    font-size: 13px;
  }
  .app > span {
    width: 52px !important; /* AppIcon đặt cỡ bằng style nội tuyến; board Mint-Hub-Phone: ô 52 */
    height: 52px !important;
  }
  .foot {
    margin-top: 0;
    font-size: 13px;
  }
  .help {
    display: none;
  }
}

/* Mint-Hub-Phone khung 2: không thanh "HANA One" — logo · ngày + chào · chuông · avatar nằm trong luồng, dưới thanh trạng thái 47 */
@media (max-width: 520px) {
  .topGreet {
    left: 16px;
    right: 16px;
    top: 63px;
  }
  .topGreet .brand {
    display: none;
  }
  .topGreet .greet {
    display: block;
    flex-grow: 1;
    min-width: 0;
  }
}
